/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Stocktake_Submit_Dialog_VarianceInputs */

const vi_stocktake_submit_dialog_variance = /** @type {(inputs: Stocktake_Submit_Dialog_VarianceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} dòng có variance`)
};

/**

* @param {Stocktake_Submit_Dialog_VarianceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_submit_dialog_variance = /** @type {((inputs: Stocktake_Submit_Dialog_VarianceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Submit_Dialog_VarianceInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_submit_dialog_variance(inputs)
});